import styled from "styled-components";

const AdminCompOffSc = styled.div`
  width: 100vw;
  position: absolute;
  top: 55px;
  padding: 20px;

`;

export default AdminCompOffSc;
